<template>
  <div class="d-flex align-items-center gap-3 flex-fill" style="min-width: 0">
    <span class="avatar avatar-md">
      {{ avatarAcronym }}
    </span>
    <div style="min-width: 0">
      <div class="card-company-name text-muted fw-medium text-truncate">
        {{ props.job.company_name }}
      </div>
      <h3 class="mb-0 text-truncate">
        <a
          :href="props.job.link"
          target="_blank"
          rel="noopener noreferrer"
          class="text-reset"
          v-tooltip="props.job.title">
          {{ props.job.title }}
        </a>
      </h3>
      <small class="text-muted">#{{ props.job.id }} &middot; {{ props.job.provider }}</small>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ExternalJobMarketJob } from '@/types/externalJobMarket';
import { getAcronym } from '@/func/string/acronym';

const props = defineProps<{ job: ExternalJobMarketJob }>();

const avatarAcronym = computed(() => {
  return getAcronym(props.job.company_name || '?').toUpperCase();
});
</script>

<style scoped>
.card-company-name {
  font-size: 13px;
  line-height: 18px;
}

h3 {
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}

h3 a:hover {
  text-decoration: underline !important;
}
</style>
